/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { Application, ApplicationList } from "../../data/interfaces";
import {
    ApplicationsAction, CreateApplicationsAction,
    CREATE_APPLICATION_FAILURE, CREATE_APPLICATION_REQUEST, CREATE_APPLICATION_SUCCESS,
    DELETE_APPLICATION_FAILURE, DELETE_APPLICATION_REQUEST, DELETE_APPLICATION_SUCCESS,
    FETCH_APPLICATION_DETAILS_FAILURE, FETCH_APPLICATION_DETAILS_REQUEST, FETCH_APPLICATION_DETAILS_SUCCESS,
    FETCH_APPLICATION_FAILURE, FETCH_APPLICATION_REQUEST, FETCH_APPLICATION_SUCCESS,
    SHARE_APPLICATION_SUCCESS,
    UPDATE_APPLICATION_FAILURE, UPDATE_APPLICATION_REQUEST, UPDATE_APPLICATION_SUCCESS
} from '../types/applications';

interface ApplicationReducerState {
    isLoading: boolean,
    applications: ApplicationList,
    error: string
}

const initialState: ApplicationReducerState = {
    isLoading: false,
    applications: { count: 0, list: [], pagination: {offset: 0, limit: 25, next: '', previous: '', total: 25} },
    error: ''
}

const applicationsReducer = (state = initialState, action: ApplicationsAction | CreateApplicationsAction) => {
    switch (action.type) {
        case FETCH_APPLICATION_REQUEST:
            return {
                ...state,
                isLoading: true,
            }
        case FETCH_APPLICATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                applications: action.payload
            }
        case FETCH_APPLICATION_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case CREATE_APPLICATION_REQUEST:
            return {
                ...state,
                isLoading: true,
            }
        case CREATE_APPLICATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                applications: {
                    list : state.applications ? [...state.applications?.list, action.payload] : [action.payload],
                    count: state.applications ? state.applications.count + 1 : 1,
                    pagination: state.applications ? state.applications.pagination : {}
                }
            }
        case CREATE_APPLICATION_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case DELETE_APPLICATION_REQUEST:
            return {
                ...state,
                isLoading: true,
            }
        case DELETE_APPLICATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                applications: {
                    count: state.applications?.count -1,
                    list: state.applications?.list.filter((app: Application) => {
                        return app.applicationId !== action.payload;
                    })
                }
            };
        case DELETE_APPLICATION_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case FETCH_APPLICATION_DETAILS_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case FETCH_APPLICATION_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                applications: { count: 1, list: [action.payload], pagination: {} }
            };
        case FETCH_APPLICATION_DETAILS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };
        case UPDATE_APPLICATION_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case UPDATE_APPLICATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                applications: {
                    ...state.applications,
                    list: [
                        ...state.applications.list.filter((app: Application) => app.applicationId !=
                            (action.payload as unknown as Application).applicationId),
                        action.payload
                    ]
                }
            };
        case UPDATE_APPLICATION_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };
        case SHARE_APPLICATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                applications: {
                    ...state.applications,
                    list: [
                        ...state.applications.list.filter((app: Application) => app.applicationId !=
                            (action.payload as unknown as Application).applicationId),
                        action.payload
                    ]
                }
            };    
        default:
            return state
    }
}

export default applicationsReducer;
